/*
 * Lazy <shopify-account> (see snippets/header-actions.liquid).
 *
 * Shopify's account.js upgrades every <shopify-account> as soon as it loads and
 * pulls in login-form.js; together that is ~0.7s of main-thread work on a phone
 * on every page. The header keeps the element in an inert <template> next to a
 * placeholder that shows the same icon/text, and this swaps the real element in
 * - signed out: on the first hover / focus / touch / click of the button
 * - signed in: when the page is idle after load, so the avatar still appears.
 */
(function () {
  if (window.acLazyAccount) return;
  window.acLazyAccount = true;

  var upgraded = false;

  function upgrade() {
    if (upgraded) return [];
    upgraded = true;
    var elements = [];
    document.querySelectorAll('[data-account-placeholder]').forEach(function (placeholder) {
      var template = placeholder.parentElement && placeholder.parentElement.querySelector('template[data-account-template]');
      if (!template) return;
      // Shopify prepends a <shopify-store> context element to the template at
      // render time; insert the whole fragment, slot the children into the
      // account element.
      var fragment = document.importNode(template.content, true);
      var element = fragment.querySelector('shopify-account') || fragment.firstElementChild;
      if (!element) return;
      while (placeholder.firstChild) element.appendChild(placeholder.firstChild);
      placeholder.replaceWith(fragment);
      elements.push(element);
    });
    return elements;
  }

  function hint(event) {
    if (upgraded) return;
    var target = event.target;
    if (!(target instanceof Element) || !target.closest('.account-button')) return;
    upgrade();
  }

  ['pointerover', 'focusin', 'touchstart'].forEach(function (type) {
    document.addEventListener(type, hint, { passive: true, capture: true });
  });

  // A click that lands before any hint (keyboard-less automation, very fast
  // taps): swap the element in and re-issue the click on its activator once it
  // has rendered; if it has no activator yet, fall back to the account page.
  document.addEventListener(
    'click',
    function (event) {
      if (upgraded) return;
      var target = event.target;
      if (!(target instanceof Element)) return;
      var placeholder = target.closest('[data-account-placeholder]');
      if (!placeholder) return;
      event.preventDefault();
      var url = placeholder.getAttribute('data-account-url');
      var element = upgrade()[0];
      var attempts = 0;
      (function retry() {
        var activator = element && element.shadowRoot && element.shadowRoot.querySelector('button, a');
        if (activator) return activator.click();
        if (attempts++ < 20) return requestAnimationFrame(retry);
        if (url) window.location.href = url;
      })();
    },
    true
  );

  if (document.querySelector('[data-account-placeholder][data-account-signed-in]')) {
    var idle = function () {
      if (window.requestIdleCallback) window.requestIdleCallback(upgrade, { timeout: 4000 });
      else setTimeout(upgrade, 1500);
    };
    if (document.readyState === 'complete') idle();
    else window.addEventListener('load', idle);
  }
})();
